import { render, staticRenderFns } from "./note.page.vue?vue&type=template&id=1be706e5&"
import script from "./note.page.vue?vue&type=script&lang=js&"
export * from "./note.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports